/* eslint-disable jsx-a11y/iframe-has-title */
import List from 'components/List';
import Maps from 'components/Maps';
import MiniCard from 'components/MiniCard';
import Layout from 'Layout'
import React, { useState } from 'react'
import { useCallback } from 'react';
import { getBatasGampong, getDusun, getOrbitasi, getPendudukDusun, getProfile } from 'services/apiRoutes';
import { useEffect } from 'react';
import HorizontalCard from 'components/HorizontalCard';
import ImGeo from 'assets/images/im-geo.webp'
import { useParams } from 'react-router-dom';

export default function Geografi() {

  const { slug } = useParams();

  const [batasGampong,setBatasGampong]=useState();
  const [dusun,setDusun]=useState();
  const [orbitasi,setOrbitasi]=useState();
  const [penduduk,setPenduduk]=useState();
  const [profile,setProfile]=useState();
  let tKK = 0;
  let tJiwa = 0;

  penduduk?.map((item)=>{
     tKK+=Number(item?.jumlahKK)
      tJiwa+=Number(item?.jumlahPenduduk)
  })


  const batasGampongAPI = useCallback(async()=>{
    const res = await getBatasGampong(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setBatasGampong(data);
    }
  },[slug])

  const dusunAPI = useCallback(async()=>{
    const res = await getDusun(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setDusun(data);
    }
  },[slug])

  const orbitasiAPI = useCallback(async()=>{
    const res = await getOrbitasi(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setOrbitasi(data);
    }
  },[slug])

  const pendudukAPI = useCallback(async()=>{
    const res = await getPendudukDusun(slug);
    if (res.error) {
      return res.message
    }else{
      const {data} = res.data;
      setPenduduk(data);
    }
  },[slug])
 
  const profileAPI = useCallback(async()=>{
    const res = await getProfile(slug);
    if (res.error) {
      return res.message
    }else{
      const {data} = res.data;
      setProfile(data);
    }
  },[slug])


  useEffect(() => {
    batasGampongAPI();
    dusunAPI();
    orbitasiAPI();
    pendudukAPI();
    profileAPI();
  }, [batasGampongAPI, dusunAPI, orbitasiAPI, pendudukAPI, profileAPI]);

  return (
    <Layout>
      <div className="px-5 xl:pt-44 py-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-18 mb-14 xl:text-7xl">
          Geografis
        </h1>
        <div className="space-y-24 wrapperCad xl:mb-32 mb-14">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Geografi"
            img={ImGeo}
          />
        </div>
        <div className="justify-center hidden xl:flex">
          <Maps
            long={profile?.ProfilDesa?.longitude}
            lat={profile?.ProfilDesa?.latitude}
          />
        </div>
        <div className="flex justify-center xl:hidden">
          <iframe
            src={`https://maps.google.com/maps?q=${profile?.ProfilDesa?.latitude},${profile?.ProfilDesa?.longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
            width="320"
            height="300"
            className="border rounded-2xl border-secondary"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <h1 className="mt-20 text-2xl font-bold mb-7 xl:text-7xl xl:mt-32">
          Batas Gampong
        </h1>
        <div className="p-4 space-y-5 wrapperDescBatas rounded-2xl bg-blurBorder xl:p-7">
          {batasGampong
            ? batasGampong.map((item, index) => (
                <List key={index} loc={item?.nama} list={item?.deskripsi} />
              ))
            : null}
        </div>
        <h1 className="mt-20 text-2xl font-bold mb-7 xl:text-7xl xl:mt-32">
          Dusun
        </h1>
        <div className="grid-cols-2 gap-5 dusunWrapper xl:grid">
          {dusun
            ? dusun?.map((item, index) => (
                <MiniCard
                  key={index}
                  title={item?.nama}
                  desc={item?.deskripsi}
                  img={item?.url_gambar}
                />
              ))
            : null}
        </div>
        <h1 className="mt-20 text-2xl font-bold mb-7 xl:text-7xl xl:mt-32">
          Demografi
        </h1>
        <div className="p-4 space-y-5 font-semibold wrapperDescBatas rounded-2xl bg-blurBorder xl:p-7">
          <p>
            Jumlah penduduk Gampong Geulanggang Teungoh pada akhir tahun 2019
            mencapai 4.732 jiwa, dengan komposisi penduduk laki-laki sejumlah
            2.388 jiwa dan perempuan sejumlah 2.344 jiwa, yang secara
            keseluruhan mencakup dalam 1.287 Kepala Keluarga (KK) yang tersebar
            dalam 4 (empat) dusun.{" "}
          </p>
        </div>
        <h1 className="mt-20 text-2xl font-bold mb-7 xl:text-7xl xl:mt-32">
          Orbitasi
        </h1>
        <div className="p-4 space-y-5 wrapperDescBatas rounded-2xl bg-blurBorder xl:p-7">
          {orbitasi
            ? orbitasi.map((item, index) => (
                <List loc={item?.deskripsi} list={item?.nama} key={index} />
              ))
            : null}
        </div>
        <h1 className="mt-20 text-2xl font-bold mb-7 xl:text-7xl xl:mt-32">
          Demografi Per Dusun
        </h1>
        <div className="flex flex-col">
          <div className="mt-16 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="min-w-full text-center">
                  <thead className="border-b bg-primary">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        KODE
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        DUSUN
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        JUMLAH KK
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        JUMLAH JIWA
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {penduduk?.map((item, index) => (
                      <tr className="bg-white border-b">
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
                          {item?.namaDusun}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
                          {item?.jumlahKK}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
                          {item?.jumlahPenduduk}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <thead className="w-full border-b bg-primary">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        JUMLAH TOTAL
                      </th>
                      <th />

                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        {tKK}
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        {tJiwa}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
